import { defineMessages } from 'react-intl';

export default defineMessages({
    creditQuestion: {
        id: '_.createNewApplicationForm.credit_question',
        defaultMessage: 'How much more would you like to borrow?'
    },
    creditError: {
        id: '_.createNewApplicationForm.credit_Error',
        defaultMessage: 'Please enter how much is required'
    },
    minCreditError: {
        id: '_.createNewApplicationForm.min_credit_Error',
        defaultMessage: 'Please enter an amount greater than {minAmount}'
    },
    maxCreditError: {
        id: '_.createNewApplicationForm.max_credit_Error',
        defaultMessage: 'The maximum you can request is {maxAmount}'
    },
    turnoverQuestion: {
        id: '_.createNewApplicationForm.turnover_question',
        defaultMessage:
            'How much did your business turnover in the last 12 months?'
    },
    turnoverError: {
        id: '_.createNewApplicationForm.turnover_Error',
        defaultMessage: 'Turnover is Required'
    },
    minTurnoverError: {
        id: '_.createNewApplicationForm.minTurnoverError',
        defaultMessage: 'Please enter an amount greater than {minAmount}'
    },
    purposeQuestion: {
        id: '_.createNewApplicationForm.purpose_question',
        defaultMessage: 'What do you want to use the loan for?'
    },
    purposeError: {
        id: '_.createNewApplicationForm.purpose_error',
        defaultMessage: 'Please select a purpose'
    },
    durationQuestion: {
        id: '_.createNewApplicationForm.duration_question',
        defaultMessage: 'How long do you need the loan for?'
    },
    durationError: {
        id: '_.createNewApplicationForm.duration_error',
        defaultMessage: 'Please select a duration'
    },
    defaultOption: {
        id: '_.createNewApplicationForm.default_option',
        defaultMessage: 'Please select an option'
    },
    alreadyApprovedMessage: {
        id: '_.createNewApplicationForm.alreadyApprovedMessage',
        defaultMessage:
            "You're already approved for {approvalAmount} - you can take your funds {hereCta}"
    },
    nextButton: {
        id: '_.createNewApplicationForm.next_button',
        defaultMessage: 'Continue'
    }
});
